<template>
  <div class="orderDetail">
    <Navbar title="订单详情" :service="true"/>
    <div class="header clearfix topBg">
      <div class="header-wrap">
        <!-- status 状态（0待支付、1配送中、2已完成、3售后、4待备餐） -->
        <div class="order-status" v-if="status == 0">待支付</div>
        <div class="order-status" v-if="status == 1">配送中</div>
        <div class="order-status" v-if="status == 2">已完成</div>
        <div class="order-status" v-if="status == 3">已取消</div>
        <div class="order-status" v-if="status == 4">待备餐</div>
        <div class="order-status" v-if="status == 5">待审核</div>
        <div class="order-status" v-if="status == 6">待退款</div>
        <div class="order-status" v-if="status == 7">退款完成</div>
        <div class="order-status" v-if="status == 8">拒绝退款</div>
        <div class="order-status" v-if="status == 9">退款中</div>
        <div class="cart" v-if="type===1">
          <div class="bed">护理站{{ address }}床</div>
          <div class="userinfo">
            <span>{{ userName }}</span>
            <span>{{ mobile }}</span>
          </div>
        </div>
      </div>
      <div class="order" style="margin-top: 10px">
        <div class="order-content">
          <div class="goods-list">
            <div class="goods-item" v-for="(item, index) in orderItems" :key="index">
              <div class="left">
                <div class="img" v-if="type===1">
                  <img class="deposit" :src="item.image" alt=""/>
                </div>
                <div class="food-img" v-else>充值</div>
                <div class="goods-info">
                  <span class="oneClampEllipsisType1">{{ type === 1 ? item.goodsName : '余额充值' }}</span>
                  <span class="oneClampEllipsisType1" v-if="type===1">{{ item.remark }}</span>
                  <span v-if="type===1">x {{ item.num }}</span>
                </div>
              </div>
              <div class="right">￥{{ item.amount }}</div>
            </div>
          </div>
          <div class="line"></div>
          <div class="total-price">
            <span>共 {{ totalNum }} 件</span>
            <span>小计￥</span>
            <span> {{ totalAmount }} </span>
          </div>
        </div>
        <div class="order-data">
          <div class="data-describe">
            <span>订单编号</span>
            <span> {{ orderNo }} </span>
          </div>
          <div class="data-describe" v-if="type===1">
            <span>余额支付</span>
            <span>￥ {{ balance }} </span>
          </div>
          <div class="data-describe">
            <span>支付方式</span>
            <span> {{ payMethod }} </span>
          </div>
          <div class="data-describe" v-if="payAmount !=='' ">
            <span>实付金额</span>
            <span>￥ {{ payAmount }} </span>
          </div>
          <div class="data-describe">
            <span>下单时间</span>
            <span>{{ orderTime }}</span>
          </div>
          <div class="data-describe" v-if="payTime">
            <span>支付时间</span>
            <span>{{ payTime }}</span>
          </div>
          <div class="data-describe" v-if="type===1">
            <span>订单来源</span>
            <!-- 0平台下单，2医院系统订单 -->
            <span v-if="orderFrom == 0">平台下单</span>
            <span v-if="orderFrom == 2">医院系统订单</span>
          </div>
        </div>
      </div>
    </div>
    <div class="btnGroup" v-if="status==0 || status==1 || status==2 || status==4">
      <button @click="orderCancel(orderId)" v-if="status==0">取消订单</button>
      <button class="themeColor" @click="goOrder(orderId)" v-if="status==0">去支付</button>
      <button class="normalBtn" v-if="(status == 1 || status == 2 || status == 4) && type != 2"
              @click="orderRefund(orderId)">申请退款
      </button>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import {Dialog, Toast} from "vant";
import wxPay from "../../utils/wxPay";

export default {
  name: "orderDetail",
  components: {Navbar},
  data() {
    return {
      orderNo: '',
      orderId: 0,
      balance: 0,
      mobile: "",
      address: '',
      orderFrom: 0,
      orderItems: [],
      orderTime: 0,
      payAmount: 0,
      payMethod: "",
      payTime: null,
      status: 10,
      totalAmount: 0,
      totalNum: 0,
      userName: "",
      type: 1,//1点餐，2充值
    }
  },
  mounted() {
    this.orderId = parseInt(this.$route.query.orderId)
    this.getOrderDetail(this.orderId)
    console.log(sessionStorage.getItem('s'))
  },
  methods: {
    getOrderDetail(orderId) {
      this.$post('/order/detail', {orderId}).then((res) => {
        if (res.status == 200) {
          this.orderId = res.data.orderId
          this.address = res.data.address
          this.balance = res.data.balance
          this.mobile = res.data.mobile
          this.orderFrom = res.data.orderFrom
          this.orderItems = res.data.orderItems
          this.orderNo = res.data.orderNo
          this.orderTime = this.getTimes.timestampToTime(res.data.orderTime)
          this.payAmount = res.data.payAmount
          this.payMethod = res.data.payMethod
          this.payTime = res.data.payTime && this.getTimes.timestampToTime(res.data.payTime)
          this.status = res.data.status
          this.totalAmount = res.data.totalAmount
          this.totalNum = res.data.totalNum
          this.userName = res.data.userName
          this.type = res.data.type
        }
      })
    },

    // 取消订单
    orderCancel(orderId) {
      Dialog.confirm({
        message: "确定取消订单吗？",
        confirmButtonColor: '#126AFC',
        overlayStyle: {'z-index': 999}
      }).then(() => {
        this.$post('order/cancel', {orderId}).then(res => {
          if (res.status == 200) {
            this.$router.go(0);
            return Toast.success('订单取消成功');
          } else {
            Toast.fail(res.msg);
          }
        })
      }).catch(() => {
      })
    },

    //申请退款
    orderRefund(orderId) {
      this.$router.push({path: '/my/orderRefund', query: {orderId}})
    },
    //支付
    goOrder(orderId) {
      // this.$router.push({path: '/order', query: {orderId}})
      this.$post('pay/getPayData', {
        orderId
      }).then(res => {
        if (res.status === 200) {
          if (res.data.appId) {
            let data = {
              appId: res.data.appId,//公众号id，必传
              nonceStr: res.data.nonceStr,//随机串，必传
              timeStamp: res.data.timeStamp,//时间戳，必传
              package: res.data.package,//必传
              signType: res.data.signType,//微信签名方式
              paySign: res.data.sign,//微信签名
            }
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                    "WeixinJSBridgeReady",
                    wxPay(data, (rec) => {
                      this.$router.go(0)
                    }, () => {
                      this.$router.replace(`/my/orderDetail?orderId=${this.orderId}`);
                    }),
                    false
                );
              } else if (document.attachEvent) {
                document.attachEvent(
                    "WeixinJSBridgeReady",
                    wxPay(data, (rec) => {
                      this.$router.go(0)
                    }, () => {
                      this.$router.replace(`/my/orderDetail?orderId=${this.orderId}`);
                    })
                );
                document.attachEvent(
                    "onWeixinJSBridgeReady",
                    wxPay(data, (rec) => {
                      this.$router.go(0)
                    }, () => {
                      this.$router.replace(`/my/orderDetail?orderId=${this.orderId}`);
                    })
                );
              }
            } else {
              wxPay(data, (rec) => {
                this.$router.go(0)
              }, () => {
                this.$router.replace(`/my/orderDetail?orderId=${this.orderId}`);
              });
            }
          } else {
            Toast('支付成功');
            this.$router.go(0)
          }
        } else {
          Toast(res.msg);
        }
      })
    },
  }
}
</script>

<style scoped lang="less">
.orderDetail {
  font-size: 12px;
  margin-bottom: 60px;

  .header {
    padding-bottom: 20px;

    .header-wrap {
      padding: 0 15px;
      box-sizing: border-box;

      .order-status {
        margin-top: 18px;
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 20px;
      }

      .cart {
        height: 75px;
        background: #FFFFFF;
        border-radius: 10px;
        color: #000000;
        padding: 0 15px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        font-size: 18px;

        .userinfo {
          font-size: 15px;
          color: #999999;
          margin-top: 15px;

          span:nth-child(2) {
            margin-left: 15px;
          }
        }
      }
    }
  }

  .order {
    padding: 0 15px 80px 15px;
    box-sizing: border-box;
    color: #000000;


    .order-content {
      background: #FFFFFF;
      border-radius: 10px;
      padding: 15px;
      box-sizing: border-box;

      .goods-list {
        .goods-item:first-child {
          margin-top: 0;
        }

        .goods-item {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-top: 15px;

          .left {
            display: flex;
            align-items: flex-start;

            .img {
              width: 55px;
              height: 55px;
              border-radius: 8px;
              overflow: hidden;
              flex-shrink: 0;

              .deposit {
                width: 100%;
                height: 100%;
                background: #EEEEEE;
                font-size: 15px;
                font-weight: bold;
                color: #999999;
                text-align: center;
                line-height: 55px;
              }
            }

            .food-img {
              width: 55px;
              height: 55px;
              background: #EEEEEE;
              border-radius: 8px;
              font-size: 15px;
              font-weight: bold;
              text-align: center;
              line-height: 55px;
              color: #999999;
              flex-shrink: 0;
            }

            .goods-info {
              margin-left: 15px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;

              span:nth-child(1) {
                font-size: 15px;
              }

              span:nth-child(2) {
                color: #999999;
                margin-top: 5px;
              }

              span:nth-child(3) {
                margin-top: 10px;
                color: #999999;
              }
            }
          }

          .right {
            font-size: 15px;
          }
        }
      }

      .line {
        width: 100%;
        height: 1px;
        background: #DDDDDD;
        margin-top: 20px;
      }

      .total-price {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;

        span:nth-child(1) {
          color: #999999;
          margin-right: 5px;
        }

        span:nth-child(3) {
          font-size: 18px;
          font-weight: bold;
          margin-left: 3px;
        }
      }
    }

    .order-data {
      border-radius: 10px;
      padding: 15px;
      box-sizing: border-box;
      background: #FFFFFF;
      margin-top: 10px;
      color: #000000;

      .data-describe:first-child {
        margin-top: 0;
      }

      .data-describe {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  .btnGroup {
    width: 100%;
    height: 60px;
    position: fixed;
    bottom: 0;
    background: #FFFFFF;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    button {
      width: 110px;
      height: 40px;
      border-radius: 20px;
      border: none;
      font-size: 15px;
      margin-right: 15px;
    }

    button:nth-child(1) {
      border: 1px solid #CCCCCC;
      color: #999999;
      background: transparent;
    }

    button:nth-child(2) {
      font-weight: bold;
    }
  }
}
</style>